import React from "react";
import Hero from "../components/Hero";
import Couriers from "../components/Couriers";
import TrackingSection from "../components/TrackingSection";
import Services from "../components/Services";

const Home = () => (
  <>
    <Hero />
    <Couriers />
    <TrackingSection />
    <Services />
  </>
);

export default Home;
